module.exports = __webpack_public_path__ + "static/pillow-3-f8c6bf854c33203a8621d5aaac983477.png";